import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IDialogDataWithAction, OkCancelDialogActions } from '@modeso/aumico-lib-core-fe';

@Component({
    selector: 'confirmation-modal',
    templateUrl: './confirmation-modal.component.html',
    styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModal {
    OkCancelDialogActions = OkCancelDialogActions;
    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: IDialogDataWithAction,
        private readonly dialogRef: MatDialogRef<ConfirmationModal, OkCancelDialogActions>,
    ) {}

    applyActionAndClose(result: OkCancelDialogActions): void {
        this.dialogRef.close(result);
    }

    closeDialog(): void {
        this.dialogRef.close();
    }
}
